import Vue from "vue";
import Vuex from "vuex";
import firebase from "firebase";
import { db, createDocObject } from "@/firebase";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

export const state = {
  user: null, // Authentication がもっているユーザー情報
  // user: {
  //   uid,
  //   displayName,
  // }
  userData: null // Firestore がもっているユーザー情報
  // userData: {
  //   id, // user.uid と一緒
  //   name,
  //   books,
  // }
};

const mutations = {
  setUser(state, user) {
    state.user = user;
  },
  setUserData(state, userData) {
    state.userData = userData;
  },
  RESET_VUEX_STATE(state) {
    Object.assign(state, JSON.parse(sessionStorage.getItem("state")));
  }
};

const actions = {
  // ログイン状態が変化するときに呼び出す
  setUserAndData({ commit }, { user, userData }) {
    commit("setUser", user);
    commit("setUserData", userData);
  },
  // ユーザーの情報を更新するときに呼び出す
  updateUserData({ state, commit }, userDataDiff) {
    // Diff = Difference
    const userData = {
      ...state.userData,
      ...userDataDiff
    };
    if (state.user) {
      return db
        .collection("users")
        .doc(state.user.uid)
        .set(userData)
        .then(() => {
          commit("setUserData", userData);
        });
    }
  }
};

const getters = {
  user(state) {
    return {
      ...state.user,
      ...state.userData
    };
  },
  isSignedIn(state) {
    return !!state.user;
  }
};

const store = new Vuex.Store({
  state,
  mutations,
  actions,
  getters,
  plugins: [
    createPersistedState({
      storage: window.sessionStorage,
      key: "amabie_project"
    })
  ]
});
export default store;

// user のログイン状態が変化したら、store を更新
firebase.auth().onAuthStateChanged(user => {
  if (user) {
    const userRef = db.collection("users").doc(user.uid);
    userRef.get().then(doc => {
      const userData = doc.exists
        ? createDocObject(doc)
        : {
            id: user.uid,
            name: user.displayName,
            genres: [],
            comment: "",
            books: [],
            questions: [],
            favQuestions: [],
            follows: [],
            followers: [],
            isDark: false
          };
      store.dispatch("setUserAndData", {
        user,
        userData
      });
      if (!doc.exists) {
        // はじめてのログインなので、 userData を firestore に保存
        userRef.set(userData);
      }
    });
  } else {
    store.dispatch("setUserAndData", { user: null, userData: null });
  }
});
